import React from 'react';
import { useAuthContext } from "v4/contexts/AuthContext";
import UserService from "api/user/user";
import './SwitchUserBanner.scss';
import { useTranslation } from "react-i18next";
import { PolIcon } from "components/PolIcon/policon";

export default function SwitchUserBanner() {
    const { user, revertSwitchUser } = useAuthContext();
    const { t } = useTranslation();

    if (!UserService.isUserSwitching()) {
        return null;
    }

    const backToMyAccountCallback = () => {
        revertSwitchUser();
        window.location.reload();
    }

    return (
        <div className="switch-user-banner">
            <div className="switch-user-banner__content">
                <span className="switch-user-banner__text">
                    <PolIcon icon="user"/>
                    <span>
                        {t('connected_as')} <b>{user?.fullname || user?.login}</b> ({user?.customer?.name})
                    </span>
                </span>
                <button
                    className="switch-user-banner__button"
                    onClick={backToMyAccountCallback}
                >
                    {t('back_to_my_account')}
                </button>
            </div>
        </div>
    );
}
